import React, { useEffect, useMemo, useRef, useState } from "react";
import { BiTachometer } from "react-icons/bi";
import TraveledCard from "../../Components/TravelCard/TravelCard";
import { RiShareBoxLine } from "react-icons/ri";
import {
  DndContext,
  useDraggable,
  useDroppable,
  closestCenter,
  DragOverlay,
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { FaChevronLeft, FaChevronRight, FaSearch } from "react-icons/fa";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import CreateAccountModal from "../../Components/CreateAccount/CreateAccount";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import img1 from "../../images/buildpipe.png";
import img2 from "../../images/phoneClock.png";
import img3 from "../../images/walletdash.png";
import img4 from "../../images/walletdash.png";
import { useDispatch } from "react-redux";
import { getEmployees, getLead, getLeadbyid, updateLead } from "../../Actions/actions";
import { useSelector } from "react-redux";
import { object } from "yup";
import { LeadDetailsModal } from "../LeadMangement/LeadManagementScreen";

const defaultStages = [
  { value: "Pending", title: "Pending" },
  { value: "Contacted", title: "Contacted" },
  { value: "Followup", title: "Follow up" },
  { value: "Prospect", title: "Prospect" },
  { value: "UnderNegotiations", title: "Under Negotiations" },
  { value: "Quotationsent", title: "Quotation sent" },
  {
    value: "MasterAgreementnegotiations",
    title: "Master Agreement negotiations",
  },
  { value: "AccountOpeninginprocess", title: "Account Opening in process" },
  { value: "Accountconverted", title: "Account converted " },
  { value: "AwaitingReceived", title: "Awaiting LPO/LPO Received" },
  { value: "PendingDelivery", title: "Pending Delivery " },
  {
    value: "ReceivedConfirmationofExecution",
    title: "Received Confirmation of Execution",
  },
];

const DraggableCard = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
  });
  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
  };
  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes} className="draggable">
      {children}
    </div>
  );
};

const DroppableZone = ({ id, children }) => {
  const { setNodeRef } = useDroppable({
    id,
  });

  return (
    <div ref={setNodeRef} className="droppable">
      {children}
    </div>
  );
};

const PipelineManagementScreen = () => {
  const { loginData, leadsData, loader, stats, Privilages } = useSelector((state) => state.userReducer);
  console.log(leadsData, "leads");
  const dispatch = useDispatch();
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const getLeaddata = () => {
    dispatch(getLead(loginData?.accessToken));
  };
  useEffect(() => {
    getLeaddata();
  }, []);
  const [travelcard, settravelcard] = useState([]);
  useEffect(() => {
    let localdata = [
      {
        label: "Total Traveled",
        value: stats?.totalTravelDistance + "km",
        icon: <img src={img1} alt="Repotal Logo" className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
      },
      {
        label: "Total Call Time",
        value: stats?.totalCallTime,
        icon: <img src={img2} className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
      },
      {
        label: "Leads in Pipeline",
        value: stats.leadsInPipeline,
        icon: <img src={img3} className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
      },
      {
        label: "Closed Deals",
        value: stats.closedDeals,
        icon: <img src={img4} className="xl:w-12 xl:h-12 sm:w-10 sm:h-10" />,
      },
    ];
    settravelcard([...localdata]);
  }, [stats]);
  const [activeTab, setActiveTab] = useState("All");
  const [startindex, setstartindex] = useState(0);
  const [endindex, setendindex] = useState(0);

  const tabs = [{ label: "All" }, { label: "Cold Leads" }, { label: "Warm Leads" }, { label: "Hot Leads" }];
  const handleTabClick = (label) => {
    if (label === "All") {
      setstartindex(0);
      setendindex(leads?.length);
    } else if (label === "Cold Leads") {
      setstartindex(1);
      setendindex(4);
      // setendindex(leads?.length);
    } else if (label === "Hot Leads") {
      setstartindex(4);
      setendindex(8);
    } else if (label === "Warm Leads") {
      setstartindex(0);
      setendindex(4);
    }
    setActiveTab(label);
  };

  const stages = useMemo(() => {
    return defaultStages.filter((stage) => {
      if (activeTab === "All") return true;
      if (activeTab === "Cold Leads") return ["Contacted", "Followup", "Prospect"].includes(stage.value);
      if (activeTab === "Warm Leads")
        return ["UnderNegotiations", "Quotationsent", "AwaitingReceived"].includes(stage.value);
      if (activeTab === "Hot Leads")
        return [
          "MasterAgreementnegotiations",
          "AccountOpeninginprocess",
          "Accountconverted",
          "ReceivedConfirmationofExecution",
        ].includes(stage.value);
      return false;
    });
  }, [activeTab]);

  const [leads, setLeads] = useState({
    Pending: [],
    Contacted: [],
    Followup: [],
    Prospect: [],
    UnderNegotiations: [],
    Quotationsent: [],
    MasterAgreementnegotiations: [],
    AccountOpeninginprocess: [],
    Accountconverted: [],
    AwaitingReceived: [],
    PendingDelivery: [],
    ReceivedConfirmationofExecution: [],
  });
  // Function to categorize leads by their status
  const categorizeLeads = (leadsData) => {
    const categorizedLeads = {
      Pending: [],
      Contacted: [],
      Followup: [],
      Prospect: [],
      UnderNegotiations: [],
      Quotationsent: [],
      MasterAgreementnegotiations: [],
      AccountOpeninginprocess: [],
      Accountconverted: [],
      AwaitingReceived: [],
      PendingDelivery: [],
      ReceivedConfirmationofExecution: [],
    };

    leadsData.forEach((lead) => {
      switch (lead.status) {
        case "Pending":
          categorizedLeads.Pending.push(lead);
          break;
        case "Contacted":
          categorizedLeads.Contacted.push(lead);
          break;
        case "Follow up":
          categorizedLeads.Followup.push(lead);
          break;
        case "Prospect":
          categorizedLeads.Prospect.push(lead);
          break;
        case "Under Negotiations":
          categorizedLeads.UnderNegotiations.push(lead);
          break;
        case "Quotation sent":
          categorizedLeads.Quotationsent.push(lead);
          break;
        case "Master Agreement negotiations":
          categorizedLeads.MasterAgreementnegotiations.push(lead);
          break;
        case "Account Opening in process":
          categorizedLeads.AccountOpeninginprocess.push(lead);
          break;
        case "Account converted":
          categorizedLeads.Accountconverted.push(lead);
          break;
        case "Awaiting LPO/LPO Received":
          categorizedLeads.AwaitingReceived.push(lead);
          break;
        case "Pending Delivery":
          categorizedLeads.PendingDelivery.push(lead);
          break;
        case "Received Confirmation of Execution":
          categorizedLeads.ReceivedConfirmationofExecution.push(lead);
          break;
        default:
          break;
      }
    });

    return categorizedLeads;
  };

  useEffect(() => {
    const categorizedLeads = categorizeLeads(leadsData);
    setLeads(categorizedLeads);
    setendindex(categorizedLeads?.length);
    setActiveTab("All");
  }, [leadsData]);
  const [activeId, setActiveId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isaccountModalOpen, setIsaccountModalOpen] = useState(false);
  const filteredLeads = Object.keys(leads).reduce((acc, stage) => {
    const filteredLeadsInStage = leads[stage].filter(
      (lead) =>
        lead.companyName.toLowerCase().includes(searchTerm) ||
        lead.leadSource.toLowerCase().includes(searchTerm) ||
        lead.leadBudget.toLowerCase().includes(searchTerm.toLowerCase())
    );
    if (filteredLeadsInStage?.length > 0) {
      acc[stage] = filteredLeadsInStage;
    }
    return acc;
  }, {});
  const [width, setWidth] = useState(getWidthByBreakpoint());

  function getWidthByBreakpoint() {
    const screenWidth = window.innerWidth;

    // Tailwind default breakpoints
    if (screenWidth < 640) {
      // sm
      return screenWidth; // smaller padding on small devices
    } else if (screenWidth < 768) {
      // md
      return screenWidth - 60;
    } else {
      // 2xl and above
      return screenWidth - 320;
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setWidth(getWidthByBreakpoint());
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // call once on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragStart = (event) => {
    const { active } = event;
    setActiveId(active.id);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (over.id === "Accountconverted" || over.id === "AccountOpeninginprocess") return;

    if (active.id !== over.id) {
      const activeStage = Object.keys(leads)?.find((stage) =>
        leads[stage].some((lead) => `${stage}-${lead.id}` === active.id)
      );
      const overStage = over.id;

      const activeIndex = leads[activeStage]?.findIndex((lead) => `${activeStage}-${lead.id}` === active.id);
      const draggedLead = leads[activeStage][activeIndex];

      const selectedStatus = stages?.find((val) => val.value === overStage);

      const previousLeadsState = { ...leads };

      const isAlreadyInTargetStage = leads[overStage].some((lead) => lead.id === draggedLead.id);

      if (!isAlreadyInTargetStage) {
        const newLeads = {
          ...leads,
          [activeStage]: leads[activeStage].filter((lead) => lead.id !== draggedLead.id),
          [overStage]: [...leads[overStage], draggedLead],
        };

        setLeads(newLeads);
      }

      dispatch(
        updateLead(
          draggedLead.id,
          { status: selectedStatus?.title },
          loginData?.accessToken,
          () => {},
          (error) => {
            if (error) {
              setLeads(previousLeadsState);
            }
          }
        )
      );
    }

    setActiveId(null);
  };

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };
  const handleEdit = (lead) => {
    dispatch(getLeadbyid(loginData?.accessToken, lead.id));
    dispatch(getEmployees(loginData?.accessToken, true));
    setIsDetailModalOpen(true);
  };
  const PrivilagesArray =
    Privilages?.length > 0 ? Privilages.filter((item) => item.feature === "Pipeline Management") : [];
  return (
    <ParentComponent>
      <PrimaryHeader />
      <div className="w-full overflow-x-hidden">
        <div className="flex flex-wrap gap-4 mb-6 w-full">
          {travelcard.map((metric, idx) => {
            return <TraveledCard metric={metric} idx={idx} />;
          })}
        </div>
        <div className="relative w-full ">
          <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border bg-transparent border-gray-300 rounded-lg pl-10 pr-4 py-3 w-full focus:outline-none focus:ring-2 focus:ring-[#361D32]"
          />
        </div>
        <div className="flex flex-wrap mt-5">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => handleTabClick(tab.label)}
              className={`flex text-gray-400  items-center sm:px-2 md:px-4 rounded-lg ${
                activeTab == tab.label ? "underline text-[grey]" : ""
              }`}
              style={{ color: activeTab == tab.label ? "black" : "gray" }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div style={{ width: width < 640 ? "100%" : `${width}px` }}>
        <div className="relative  ">
          <button
            className="absolute right-20 -mt-9   top-2/2  z-10 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md"
            onClick={scrollLeft}
          >
            <FaChevronLeft />
          </button>

          <button
            className="absolute right-10 -mt-9 top-2/2  z-10 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md"
            onClick={scrollRight}
          >
            <FaChevronRight />
          </button>
        </div>
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragStart={
            PrivilagesArray?.length > 0
              ? PrivilagesArray[0].accessLevel !== "View Only"
                ? handleDragStart
                : () => {}
              : handleDragStart
          }
          onDragEnd={
            PrivilagesArray?.length > 0
              ? PrivilagesArray[0].accessLevel !== "View Only"
                ? handleDragEnd
                : () => {}
              : handleDragEnd
          }
        >
          <div ref={scrollRef} className="w-full flex flex-row mb-6 mt-6 overflow-x-scroll scrollbar-none">
            {stages.map((stage, idx) => (
              <DroppableZone key={idx} id={stage.value}>
                <div className="flex flex-col justify-center items-center mx-[7px] w-[200px]  mb-6">
                  <div className="text-xs px-2 py-1 bg-gray-200 rounded-lg text-center mb-4  w-[100%]">
                    <span className="text-gray-700 text-sm font-medium">
                      {stage.title?.length > 20
                        ? stage.title
                            .slice(0, 20)
                            .replace(/([A-Z])/g, " $1")
                            .trim() + "..."
                        : stage.title.replace(/([A-Z])/g, " $1").trim()}
                    </span>
                  </div>
                  <div className="space-y-4 w-[100%]">
                    {filteredLeads[stage.value]?.length > 0 ? (
                      filteredLeads[stage.value].map((lead) => (
                        <DraggableCard key={lead.id} id={`${stage.value}-${lead.id}`}>
                          <div className=" p-4  rounded-2xl shadow-md   bg-white w-full">
                            <div className="mb-4">
                              <span className="text-xs px-2 py-1 bg-gray-200 rounded-lg">
                                {lead?.leadSource?.length > 20
                                  ? lead?.leadSource.slice(0, 20) + "..."
                                  : lead?.leadSource}
                              </span>
                            </div>
                            <h3 className="text-md font-semibold mb-2">
                              {lead.companyName?.length > 15
                                ? lead?.companyName?.slice(0, 15) + "..."
                                : lead?.companyName}
                            </h3>
                            <p className="text-sm text-black">Lead Owner</p>
                            <div className="flex items-center my-3 justify-between">
                              <div className="">
                                <img
                                  src={
                                    lead?.salesRep?.logo
                                      ? lead?.salesRep?.logo
                                      : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH5sFjZPx1Yzi1b9_FpQzrxqgsjv2DPAp81Q&s"
                                  }
                                  className="w-[35px] h-[35px] rounded-full"
                                />
                              </div>
                              <div className="w-[70%] pl-1">
                                <p className="text-sm font-semibold">
                                  {lead?.salesRep?.FullName?.length > 10
                                    ? lead?.salesRep?.FullName?.slice(0, 10) + "..."
                                    : lead?.salesRep?.FullName}
                                </p>
                              </div>
                              <div
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  handleEdit(lead);
                                }}
                                className="w-[10%]"
                              >
                                <RiShareBoxLine className="text-gray-600 w-5 h-5" />
                              </div>
                            </div>
                            <div className="flex justify-between text-sm items-center">
                              <span className="text-black">Deal Value:</span>
                              <span className="font-semibold text-xs">AED {lead.leadBudget}</span>
                            </div>
                          </div>
                        </DraggableCard>
                      ))
                    ) : (
                      <div className="text-gray-500 text-sm text-center h-[200px] content-center">
                        No lead available
                      </div>
                    )}
                  </div>
                </div>
              </DroppableZone>
            ))}
          </div>
        </DndContext>
      </div>
      <LeadDetailsModal
        PrivilagesCondition={
          PrivilagesArray?.length > 0 ? (PrivilagesArray[0].accessLevel !== "View Only" ? true : false) : true
        }
        isOpen={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
        leadData={selectedLead}
        onConfirm={() => {
          getLeaddata();
        }}
      />
    </ParentComponent>
  );
};

export default PipelineManagementScreen;
